import { useMutation } from '@tanstack/react-query';
import axiosInstance from '../lib/axios';

export type TranslationLocale = 'en' | 'vi';

export interface TranslateTextsInput {
  sourceLocale: TranslationLocale;
  targetLocale: TranslationLocale;
  fields: Record<string, string>;
}

interface ApiResponse<T = unknown> {
  success: boolean;
  data?: T;
  message?: string;
  error?: string;
}

export const translateTexts = async ({
  sourceLocale,
  targetLocale,
  fields,
}: TranslateTextsInput): Promise<Record<string, string>> => {
  const response = await axiosInstance.post<ApiResponse<{ fields: Record<string, string> }>>(
    '/v1/admin/text-translations',
    {
      sourceLocale,
      targetLocale,
      fields,
    }
  );

  return response.data.data?.fields ?? {};
};

export const useTranslateTexts = () => {
  return useMutation({
    mutationFn: translateTexts,
  });
};
